import React, {PureComponent} from "react"

import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import medicalTracking from "@irati-tracking/medical"

interface Props {
  activationCode: string
  trackingLocation: string
}

class InsuranceButton extends PureComponent<Props> {
  handleClick = () => {
    // todo add pdf download logic once medical has access to insurance pdf document
    const {activationCode, trackingLocation} = this.props
    medicalTracking.downloadPolicy(activationCode, trackingLocation)
  }

  render() {
    return (
      <Button full large onClick={this.handleClick}>
        <FormattedMessage id="medical.insurance.button" />
      </Button>
    )
  }
}

export default InsuranceButton
